// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewTrackingSkeleton-goBackSkeleton-lnuSG {
    max-width: 78px;
    height: 26px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
    margin-bottom: 18px;
}

.ViewTrackingSkeleton-viewTrackingSkeletonContainer-Nqv0B {
    display: grid;
    grid-template-columns: calc(100% - 428px) 404px;
    gap: 24px;
    grid-gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.ViewTrackingSkeleton-viewTrackingSkeletonMapContainer-iZZsy {
    position: relative;
    width: 100%;
    height: 590px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-3);
    border: 1px solid var(--primary-border);
}

.ViewTrackingSkeleton-viewTrackProviderDetailsSkeletonBox-Cr3Ix {
    position: absolute;
    top: 18px;
    right: 18px;
}

.ViewTrackingSkeleton-viewTrackProviderDetailsSkeleton-gLaDv {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    background: var(--skeleton-primary-bg);
    padding: 12px;
    border-radius: var(--radius-2);
    -webkit-box-shadow: 0px 2px 6px 0px var(--shadow-4);
            box-shadow: 0px 2px 6px 0px var(--shadow-4);
    min-width: 339px;
    max-width: 339px;
}

.ViewTrackingSkeleton-viewTrackProviderDetailsImgSkeleton-Ik_7D {
    position: relative;
    width: 62px;
    height: 62px;
    border-radius: var(--radius-1);
    background: var(--skeleton-secondary-bg);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ViewTrackingSkeleton-providerCardDetailsSkeletonInfoContainer-xquLk {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 12px;
    grid-gap: 12px;
}

.ViewTrackingSkeleton-providerCardInfoTitleSkeleton-h_nCq,
.ViewTrackingSkeleton-providerCardInfoDesSkeleton-_cxWG {
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewTrackingSkeleton-providerCardInfoTitleSkeleton-h_nCq {
    max-width: 66px;
    height: 28px;
}

.ViewTrackingSkeleton-providerCardInfoDesSkeleton-_cxWG {
    max-width: 120px;
    height: 26px;
}

.ViewTrackingSkeleton-providerCardDetailsSkeletonHeadingBox-tDur_ {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 3px;
}

.ViewTrackingSkeleton-providerCardDetailsSkeletonIcon-hPrRf {
    position: relative;
    width: 42px;
    height: 42px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewTrackingSkeleton-providerCardDetailsSkeletonIconContainer-fWlJJ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

@media (min-width: 1200px) {
    .ViewTrackingSkeleton-viewTrackingSkeletonSkeletonRsContainer-FHu5n {
        position: sticky;
        top: 100px;
    }
}

@media (max-width: 1199px) and (min-width: 992px) {
    .ViewTrackingSkeleton-viewTrackingSkeletonSkeletonRsContainer-FHu5n {
        position: sticky;
        top: 88px;
    }
}

@media (max-width: 991px) {
    .ViewTrackingSkeleton-viewTrackingSkeletonContainer-Nqv0B {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
    }
}

@media (max-width: 767px) {
    .ViewTrackingSkeleton-viewTrackingSkeletonMapContainer-iZZsy {
        height: 365px;
    }

    .ViewTrackingSkeleton-viewTrackProviderDetailsImgSkeleton-Ik_7D {
        width: 48px;
        height: 48px;
    }

    .ViewTrackingSkeleton-providerCardDetailsSkeletonIcon-hPrRf {
        width: 36px;
        height: 36px;
    }
}

@media (max-width: 575px) {
    .ViewTrackingSkeleton-viewTrackProviderDetailsSkeletonBox-Cr3Ix {
        top: 6px;
        right: 6px;
        left: 6px;
    }

    .ViewTrackingSkeleton-viewTrackProviderDetailsSkeleton-gLaDv {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
    }

    .ViewTrackingSkeleton-providerCardDetailsSkeletonInfoContainer-xquLk {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/ViewTrackingSkeleton/ViewTrackingSkeleton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+CAAwD;IACxD,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,8BAA8B;IAC9B,mDAA2C;YAA3C,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAGA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAGA;IACI;QACI,oBAAa;QAAb,oBAAa;QAAb,aAAa;QACb,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,mBAAe;YAAf,eAAe;IACnB;AACJ","sourcesContent":[".goBackSkeleton {\n    max-width: 78px;\n    height: 26px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n    margin-bottom: 18px;\n}\n\n.viewTrackingSkeletonContainer {\n    display: grid;\n    grid-template-columns: calc((100% - 404px) - 24px) 404px;\n    gap: 24px;\n    grid-gap: 24px;\n    align-items: flex-start;\n}\n\n.viewTrackingSkeletonMapContainer {\n    position: relative;\n    width: 100%;\n    height: 590px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-3);\n    border: 1px solid var(--primary-border);\n}\n\n.viewTrackProviderDetailsSkeletonBox {\n    position: absolute;\n    top: 18px;\n    right: 18px;\n}\n\n.viewTrackProviderDetailsSkeleton {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    background: var(--skeleton-primary-bg);\n    padding: 12px;\n    border-radius: var(--radius-2);\n    box-shadow: 0px 2px 6px 0px var(--shadow-4);\n    min-width: 339px;\n    max-width: 339px;\n}\n\n.viewTrackProviderDetailsImgSkeleton {\n    position: relative;\n    width: 62px;\n    height: 62px;\n    border-radius: var(--radius-1);\n    background: var(--skeleton-secondary-bg);\n    flex-shrink: 0;\n}\n\n.providerCardDetailsSkeletonInfoContainer {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.providerCardInfoTitleSkeleton,\n.providerCardInfoDesSkeleton {\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.providerCardInfoTitleSkeleton {\n    max-width: 66px;\n    height: 28px;\n}\n\n.providerCardInfoDesSkeleton {\n    max-width: 120px;\n    height: 26px;\n}\n\n.providerCardDetailsSkeletonHeadingBox {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.providerCardDetailsSkeletonIcon {\n    position: relative;\n    width: 42px;\n    height: 42px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.providerCardDetailsSkeletonIconContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n@media (min-width: 1200px) {\n    .viewTrackingSkeletonSkeletonRsContainer {\n        position: sticky;\n        top: 100px;\n    }\n}\n\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .viewTrackingSkeletonSkeletonRsContainer {\n        position: sticky;\n        top: 88px;\n    }\n}\n\n\n@media (max-width: 991px) {\n    .viewTrackingSkeletonContainer {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n    }\n}\n\n@media (max-width: 767px) {\n    .viewTrackingSkeletonMapContainer {\n        height: 365px;\n    }\n\n    .viewTrackProviderDetailsImgSkeleton {\n        width: 48px;\n        height: 48px;\n    }\n\n    .providerCardDetailsSkeletonIcon {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n@media (max-width: 575px) {\n    .viewTrackProviderDetailsSkeletonBox {\n        top: 6px;\n        right: 6px;\n        left: 6px;\n    }\n\n    .viewTrackProviderDetailsSkeleton {\n        width: 100%;\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n    .providerCardDetailsSkeletonInfoContainer {\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goBackSkeleton": `ViewTrackingSkeleton-goBackSkeleton-lnuSG`,
	"viewTrackingSkeletonContainer": `ViewTrackingSkeleton-viewTrackingSkeletonContainer-Nqv0B`,
	"viewTrackingSkeletonMapContainer": `ViewTrackingSkeleton-viewTrackingSkeletonMapContainer-iZZsy`,
	"viewTrackProviderDetailsSkeletonBox": `ViewTrackingSkeleton-viewTrackProviderDetailsSkeletonBox-Cr3Ix`,
	"viewTrackProviderDetailsSkeleton": `ViewTrackingSkeleton-viewTrackProviderDetailsSkeleton-gLaDv`,
	"viewTrackProviderDetailsImgSkeleton": `ViewTrackingSkeleton-viewTrackProviderDetailsImgSkeleton-Ik_7D`,
	"providerCardDetailsSkeletonInfoContainer": `ViewTrackingSkeleton-providerCardDetailsSkeletonInfoContainer-xquLk`,
	"providerCardInfoTitleSkeleton": `ViewTrackingSkeleton-providerCardInfoTitleSkeleton-h_nCq`,
	"providerCardInfoDesSkeleton": `ViewTrackingSkeleton-providerCardInfoDesSkeleton-_cxWG`,
	"providerCardDetailsSkeletonHeadingBox": `ViewTrackingSkeleton-providerCardDetailsSkeletonHeadingBox-tDur_`,
	"providerCardDetailsSkeletonIcon": `ViewTrackingSkeleton-providerCardDetailsSkeletonIcon-hPrRf`,
	"providerCardDetailsSkeletonIconContainer": `ViewTrackingSkeleton-providerCardDetailsSkeletonIconContainer-fWlJJ`,
	"viewTrackingSkeletonSkeletonRsContainer": `ViewTrackingSkeleton-viewTrackingSkeletonSkeletonRsContainer-FHu5n`
};
module.exports = ___CSS_LOADER_EXPORT___;
